export default[
  {
    path: '/dataList/salary',
    component: resolve => require(['../page.vue'], resolve),
    meta: {
        title: '工资条',
        authLogin: true
    }
  },
]